/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 12th 2021, 1:13:53 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { WritableModel } from "lib/schemas/abstract";
import { PrimaryKeyValue } from "lib/types";
import {
  Portal,
  ProcessTemplateArtifact,
  ProcessTemplateArtifactSchemaType,
  ProcessTemplateArtifactValidationSchema,
} from "lib/schemas";
import { schemaBuilder } from "lib/validation";

export interface ProcessTemplateCategory extends WritableModel<false>, ProcessTemplateArtifact {
  title: string;
  active: boolean;
  site: PrimaryKeyValue<Portal>;
  sequence: number;
}

type WriteOnlyProcessTemplateCategory = Pick<ProcessTemplateCategory, "title" | "active" | "site" | "artifact_org">;

export const ProcessTemplateCategoryValidationSchema: ProcessTemplateArtifactSchemaType<WriteOnlyProcessTemplateCategory> =
  ProcessTemplateArtifactValidationSchema.shape({
    title: schemaBuilder.string().required(),
    active: schemaBuilder.boolean().required(),
    site: schemaBuilder.number().required(),
  });
